import { UserDetailsContext } from "App";
import Error404 from "app/Error404";
import { useContext } from "react";
import { Navigate, Route } from "react-router-dom";
import { Root } from "./Root";
import { isLocalhost, PRODUCT_CONTEXT } from "common-ui-components/components/utils/Config";
import { PRODUCT_CONFIG } from "ProductConfig";
import { isProduction } from "common-ui-components/components/utils/Config";

/*---------------------------------------------------------------------------------------------
For explicit module and submodule removal for all Org from navlist, 
routes and also from roles form list for App Domain
------------------------------------------------------------------------------------------------*/

const modulesToBeRemovedForApp = ["API_EXPLORER",];
const subModulesToBeRemovedForApp =  ["API_EXPLORER","SESSION_REPORTS"];
const subModulesToBeRemovedForAppLab =  [];

// Replaced hardcoded domain and window.location check with the utility function
const hide = isProduction();
// const hide=isLocalhost()

//Logic for restricting modules for all org for App Domain
const restrictModulesForApp = (objectArrays) => {
  if (hide) 
    {
    modulesToBeRemovedForApp.forEach((removeKey) => {
      const index = objectArrays.findIndex((item) => item.key === removeKey);
      if (index !== -1) objectArrays.splice(index, 1);
    });
  }
  return objectArrays;
};

//Logic for restricting sub modules across all modules for all org for App Domain
const restrictSubModulesForApp = (objectArrays) => {
  if (hide) 
  {
    const filterRecursive = (arr) => {
      return arr
        .map((item) => {
          if (item.key && subModulesToBeRemovedForApp.includes(item.key)) {
            return null;
          }
          if (item.items && Array.isArray(item.items)) {
            const filteredItems = filterRecursive(item.items);
            if (filteredItems.length > 0)
              return { ...item, items: filteredItems };
            return null;
          }
          return item;
        })
        .filter(Boolean);
    };
    // Apply recursive filter to top-level array
    objectArrays = filterRecursive(objectArrays);
  }
  if (window.location.hostname === "applab.zecurit.com")
  {
    const filterRecursive = (arr) => {
      return arr
        .map((item) => {
          if (item.key && subModulesToBeRemovedForAppLab.includes(item.key)) {
            return null;
          }
          if (item.items && Array.isArray(item.items)) {
            const filteredItems = filterRecursive(item.items);
            if (filteredItems.length > 0)
              return { ...item, items: filteredItems };
            return null;
          }
          return item;
        })
        .filter(Boolean);
    };
    // Apply recursive filter to top-level array
    objectArrays = filterRecursive(objectArrays);
  }
  return objectArrays;
};

//Logic for removing unwanted modules and sub modules from the Feature listing in roles form for App Domain
export const removeModulesAndSubModulesForApp = (object) => {
  if (hide) {
    const updatedObject = { ...object };
    //remove unwanted modules
    Object.keys(updatedObject).forEach((module) => {
      if (modulesToBeRemovedForApp.includes(module)) {
        delete updatedObject[module];
      }
    });
    // remove unwanted sub-modules
    Object.keys(updatedObject).forEach((module) => {
      const value = updatedObject[module];
      if (Array.isArray(value)) {
        updatedObject[module] = value.filter(
          (subModule) => !subModulesToBeRemovedForApp.includes(subModule),
        );
      }
    });
    return updatedObject;
  }
  return object;
};

/*--------------------------------------------------------------------------------------
For explicit module rendering only when it is included in product in product config with all its related containers for all Org from navlist,routes and also from roles form
----------------------------------------------------------------------------------------*/

const modulesToBeRenderedForTheProduct =
  PRODUCT_CONFIG[PRODUCT_CONTEXT]?.routeGroups || [];
const renderModulesForProduct = (objectArrays) => {
  return objectArrays.filter((item) =>
    modulesToBeRenderedForTheProduct.includes(item.key),
  );
};

/*---------------------------------------------------------------------------------------------
For explicit module and submodule removal of related containers across site for all Org for App Domain and also for Plan
------------------------------------------------------------------------------------------------*/
//Logic for hiding container(children) related to modules / submodules to be hided for all org for App Domain and also for plan
//And also product specific hide

export const ContainerToHide = ({
  children,
  moduleOrSubModulekey,
  products,
}) => {
  if (hide && moduleOrSubModulekey) {
    const modulesAndSubModulesToBeRemoved = [
      ...modulesToBeRemovedForApp,
      ...subModulesToBeRemovedForApp,
    ];
    return modulesAndSubModulesToBeRemoved.includes(moduleOrSubModulekey)
      ? false
      : children;
  }
  if (products) return products.includes(PRODUCT_CONTEXT) ? children : false;
  return children;
};

//also used for blocking but specific in reports alone
export const whetherToShowFeature = (moduleOrSubModulekey) => {
  const modulesAndSubModulesToBeRemoved = [
    ...modulesToBeRemovedForApp,
    ...subModulesToBeRemovedForApp,
  ];
  if (hide)
    return modulesAndSubModulesToBeRemoved.includes(moduleOrSubModulekey)
      ? false
      : true;
  return true;
};

/*--------------------------------------------------------------------------------------------------------------
    FeatureHider Component :-
    --- Feature hinding for hiding specific feature for some orgs through userdetails API
    --- comment this component in App or dont sent featureMap in userDetails api inorder to disable hiding function
    --- this component run at first so that permittedFeatureMap variable is loaded with featureMap in userDetails api
--------------------------------------------------------------------------------------------------------------------*/

let permittedFeatureMap = null; //global variable for storing the permitted feature in map form

const FeatureHider = () => {
  const userDetails = useContext(UserDetailsContext);
  permittedFeatureMap = userDetails?.featureMap || null;

  // permittedFeatureMap=userDetails?.featureMap || featureMap;    /* for testing*/
  if (permittedFeatureMap) {
    permittedFeatureMap["SETTINGS"] = [
      ...permittedFeatureMap["SETTINGS"],
      ...permittedFeatureMap["INVENTORY"],
      ...permittedFeatureMap["REMOTE"],
      ...permittedFeatureMap["SECURITY_SETTINGS"],
      ...permittedFeatureMap["ENROLLMENT"],
    ];
  }
  return null;
};

//for feature hide message if needed
export const FeatureHidedPage = () => {
  return (
    <div style={{ font: "18px black solid", padding: "0.8rem" }}>
      This feature is not available for this Org
    </div>
  );
};

/*
    Example routeList
    --- used to render Redirect and Route component dynamically for hiding the components needed
    const routesList = [
        {
            type: "redirect",                ---- for rendering Redirect component inside Switch
            from: path,
            to: `${path}/overview`,
            exact: true
        },
        {                                        ---- for rendering Route component inside Switch
            type: "route",                      ----- no key so it is displayed default,no hiding
            path: `${path}/overview`,
            component: Overview,
        },
        {
            key: "SOFTWARE_LICENSE",           --- feature will be displayed if the  key there in the list sent by backend
            type: "route",
            path: `${path}/software-license`,
            component: Licenses,
        },
    ]
*/
export const renderPermittedRoutes = (routeList, module) => {
  let featureList = null;
  if (module === "Root") {
    featureList = permittedFeatureMap ? Object.keys(permittedFeatureMap) : null;
    //route rendering is done in App,js itself for product specific module rendering
    routeList = restrictModulesForApp(routeList); //restriction of Modules routes all org for App Domain
  } else {
    featureList = permittedFeatureMap ? permittedFeatureMap[module] : null;
    routeList = restrictSubModulesForApp(routeList); //restriction of Submodules routes all org for App Domain
  }

  // Find common prefix to convert v5 absolute paths to v6 relative paths
  let commonPrefix = "";
  const validPaths = routeList.map((r) => r.path || r.from).filter(Boolean);
  if (validPaths.length > 0) {
    const splitPaths = validPaths.map((p) => p.split("/"));
    let i = 0;
    while (i < splitPaths[0].length) {
      const part = splitPaths[0][i];
      if (splitPaths.every((p) => p[i] === part)) {
        i++;
      } else {
        break;
      }
    }
    commonPrefix = splitPaths[0].slice(0, i).join("/");
  }

  const getRelative = (p) => {
    if (!p) return p;
    if (p.startsWith(commonPrefix)) {
      let rel = p.substring(commonPrefix.length);
      if (rel.startsWith("/")) rel = rel.substring(1);
      return rel;
    }
    return p;
  };

  const renderedRoutes = routeList.map((route, index) => {
    if (route.renderOnlyIf === false) return null;
    //condition to hide out the routes
    //hiding dont work if featureList is null or key is not given
    if (featureList && route.key && !featureList.includes(route.key)) {
      if (route.type === "inner-route") return null;

      let childPath = getRelative(route.path);
      if (module === "Root" && childPath !== "" && !childPath.endsWith("/*")) {
        childPath += "/*";
      }

      if (childPath === "") {
        if (module === "Root") {
          return (
            <Route
              key={index}
              index
              element={
                <Root>
                  <FeatureHidedPage />
                </Root>
              }
            />
          );
        }
        return <Route key={index} index element={<FeatureHidedPage />} />;
      }

      if (module === "Root") {
        return (
          <Route
            key={index}
            path={childPath}
            element={
              <Root>
                <FeatureHidedPage />
              </Root>
            }
          />
        );
      }
      return (
        <Route key={index} path={childPath} element={<FeatureHidedPage />} />
      );
    }
    //create a redirect component
    if (route.type === "redirect") {
      let childFrom = getRelative(route.from);
      if (childFrom === "") {
        return (
          <Route
            key={index}
            index
            element={<Navigate to={route.to} replace />}
          />
        );
      }
      return (
        <Route
          key={index}
          path={childFrom}
          element={<Navigate to={route.to} replace />}
        />
      );
    }
    //create a route component
    if (route.type === "route") {
      const RouteComponent = route.component;
      const routeElement = RouteComponent ? (
        <RouteComponent />
      ) : typeof route.render === "function" ? (
        route.render()
      ) : null;

      let childPath = getRelative(route.path);
      if (module === "Root" && childPath !== "" && !childPath.endsWith("/*")) {
        childPath += "/*";
      }

      if (childPath === "") {
        return <Route key={index} index element={routeElement} />;
      }

      return <Route key={index} path={childPath} element={routeElement} />;
    }
    return null;
  });

  const filteredRoutes = renderedRoutes.filter(Boolean);

  // console.log(
  //   filteredRoutes.map((r) => ({
  //     path: r.props?.path,
  //     index: r.props?.index,
  //     key: r.key,
  //   })),
  // );

  //adds a 404 page route at last for * path
  if (module === "Root")
    filteredRoutes.push(
      <Route
        key="404Page"
        path="*"
        element={
          <Root>
            <Error404 />
          </Root>
        }
      />,
    );
  else
    filteredRoutes.push(
      <Route key="404Page" path="*" element={<Error404 />} />,
    );
  return filteredRoutes;
};

/*
    const navList = [
    {
        label: "Overview",
        url: urlPrefix + "/overview"     ---- no key so no hiding of links
    },
    {
        label: "Devices",
        url: urlPrefix + "/devices"
    },
    {
        label: "Device Locations",
        url: urlPrefix + "/deviceLocations",        -------- no key present in the list hiding occurs
        key: "GEO_LOCATION"
    },
    {
        heading: "Enrollment",
        items: [
            {
                label: "Devices",
                url: "/app/settings/enrollment/devices",
                key: "AGENT",
                component: <Devices settingURL={true} />,
            },
            {
                label: "Domain",
                url: "/app/settings/enrollment/domain",
                key: "DOMAIN",
                component: <Domains />,
            }
        ],
    },
    the method handles Navlinks of modules and of the root also...
*/

export const filterPermittedNavList = (navList, module) => {
  let featureList = null;
  if (module === "Root") {
    featureList = permittedFeatureMap ? Object.keys(permittedFeatureMap) : null;
    navList = renderModulesForProduct(navList);
    navList = restrictModulesForApp(navList); //restriction of Modules navlinks all org for App Domain
  } else {
    featureList = permittedFeatureMap ? permittedFeatureMap[module] : null;
    navList = restrictSubModulesForApp(navList); //restriction of Submodules navlinks all org for App Domain
  }

  //filtering of navLinks dont occur if featureList is null
  if (!featureList) return navList;

  return navList
    .map((item) => {
      // If item has nested items, recurse
      if (item.items && Array.isArray(item.items)) {
        const filteredItems = filterPermittedNavList(item.items, module);

        // If children left, keep parent with filtered children
        if (filteredItems.length > 0) return { ...item, items: filteredItems };

        // If no children left, remove parent
        return null;
      }

      // If item has key, include only if present in featureList
      if (item.key) return featureList.includes(item.key) ? item : null;

      // If no key, add the link
      return item;
    })
    .filter(Boolean); // remove nulls
};

export default FeatureHider;
